import { create } from 'zustand'
import type { AuthIdentity } from '@/types/auth'

type AuthStatus = 'loading' | 'authenticated' | 'unauthenticated'

interface AuthState {
  identity: AuthIdentity | null
  status: AuthStatus
  setIdentity: (identity: AuthIdentity | null) => void
  setStatus: (status: AuthStatus) => void
  clear: () => void
}

export const useAuthStore = create<AuthState>((set) => ({
  identity: null,
  status: 'loading',
  setIdentity: (identity) => set({ identity, status: identity ? 'authenticated' : 'unauthenticated' }),
  setStatus: (status) => set({ status }),
  clear: () => set({ identity: null, status: 'unauthenticated' }),
}))
